import clsx from 'clsx'
import { memo, useEffect, useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'

import { MAIN } from '../../constants/paths'
import { PAGE_INFO } from '../Header/constants'
import { SECTIONS } from './constants'
import useStyles from './styles'

interface Props {
  item: {
    icon: ({ className }: { className: string }) => JSX.Element
    activeIcon: ({ className }: { className: string }) => JSX.Element
    path: string
    section: string
  }
  index: number
  onClick: () => void
}

function NavLinkWrap({ item, index, onClick }: Props) {
  const classes = useStyles({})
  const [isActive, setIsActive] = useState(false)
  const location = useLocation()

  useEffect(() => {
    if (location.pathname === MAIN) {
      setIsActive(item.section === SECTIONS.DASHBOARD)
    } else {
      setIsActive(PAGE_INFO[location.pathname]?.section === item.section)
    }
  }, [item.path, item.section, location.pathname])

  return (
    <NavLink
      key={item.path}
      onClick={onClick}
      to={item.path}
      className={clsx(classes.link, {
        [classes.active]: isActive,
        [classes.dashoardIcon]: index === 0,
      })}
    >
      <item.icon className={classes.linkIcon} />
    </NavLink>
  )
}

export default memo(NavLinkWrap)
